import styled from "styled-components";

export const StyledContainer = styled.section`
  min-width: 320px;
  flex-shrink: 0;
  height: 600px;
  position: sticky;
  top: 130px;
`;
